import React from 'react';
import {number} from 'prop-types';
import SelectInput from '@sabre/spark-react-core/select-input';

const SearchCriteriaModalCriteriaCategory = ({
                                                 key,
                                                 criteriaCategoryOptions,
                                                 criteriaCategory,
                                                 criteriaCategoryOnChangeHandler,
                                                 rowIndex,
                                                 completeSearchSet
}) => {

    return <SelectInput
        key={key}
        name={`Criteria Category${rowIndex}`}
        options={criteriaCategoryOptions}
        value={criteriaCategory}
        label='Criteria Category'
        disabled={rowIndex === 0}
        defaultValue={criteriaCategoryOptions[0].value}
        onChange={selectedValue => criteriaCategoryOnChangeHandler(selectedValue, completeSearchSet, rowIndex)}
    />;
};

SearchCriteriaModalCriteriaCategory.propTypes = {
    rowIndex: number
};

export default SearchCriteriaModalCriteriaCategory;
